<template>
  <li class="list-inline-item">
    <slot></slot>
  </li>
</template>

<script>
export default {}
</script>
